export default {"src":"/_next/static/media/icon-coin.908eb5aa.svg","height":120,"width":122,"blurWidth":0,"blurHeight":0};